export const fileToBase64 = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const base64 = (reader.result as string).split(',')[1];
      if (base64) resolve(base64);
      else reject(new Error('Could not parse base64'));
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
};
